const INVITE_LINK_INVALID = "This invitation link is invalid or has expired.";

export const AUTH_TOAST_ACCOUNT_SETUP_COMPLETE = "Account setup complete.";
export const AUTH_TOAST_CHECK_INBOX_RESET_CODE = "Check your inbox for a reset code.";
export const AUTH_TOAST_GENERIC_ERROR = "Something went wrong. Please try again.";
export const AUTH_TOAST_PASSWORD_RESET_SUCCESS = "Password reset successfully. Please sign in.";
export const AUTH_TOAST_SIGN_IN_INVALID = "Invalid email or password. Please try again.";
export const AUTH_TOAST_SIGN_IN_GENERIC = "Unable to sign in. Please try again.";
export const AUTH_ERROR_ACCOUNT_DEACTIVATED =
  "Your user has been deactivated. Please contact your organization admin for more details.";
export const AUTH_TOAST_ACCEPT_INVITE_INVALID = INVITE_LINK_INVALID;
export const AUTH_TOAST_ACCEPT_INVITE_GENERIC = "Unable to accept invitation. Please try again.";
export const AUTH_TOAST_CORRECT_HIGHLIGHTED_FIELDS = "Please correct highlighted fields.";
export const AUTH_ERROR_RESET_CODE_INVALID =
  "This code is invalid or has expired. Please request a new one.";
export const AUTH_TOAST_RESET_GENERIC = "Unable to reset password. Please try again.";

export const AUTH_LABEL_PASSWORD_STRENGTH_WEAK = "Weak";
export const AUTH_LABEL_PASSWORD_STRENGTH_MEDIUM = "Medium";
export const AUTH_LABEL_PASSWORD_STRENGTH_STRONG = "Strong";

export const AUTH_TEXT_INVITE_LINK_INVALID = INVITE_LINK_INVALID;
export const AUTH_TEXT_INVITE_VALIDATE_FAILED = "Unable to validate invitation. Please try again.";

export const AUTH_OTP_RESEND_SENDING = "Sending...";
export const AUTH_OTP_RESEND_CTA = "Resend";

export const PROFILE_LOAD_ERROR_TITLE = "We couldn't load your profile";
export const PROFILE_LOAD_ERROR_HINT = "Please check your connection and try again.";
export const PROFILE_LOAD_ERROR_SIGN_OUT = "Sign out";
export const PROFILE_LOAD_ERROR_SIGN_IN_AGAIN = "Sign in again";
export const PROFILE_LOAD_ERROR_RETRIES_EXHAUSTED_HINT =
  "We still couldn't load your profile. Please sign in again, or contact support if this keeps happening.";
